<template>
  <div id="satXMLDownloadComponent">
    <page-title
      :heading="heading"
      :subheading="subheading"
      :icon="icon"
    ></page-title>
    <v-container>
      <v-layout class="mb-2" row wrap>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="satXmlDownloadSearch"
          :label="$t('general.search')"
          clearable
          append-outer-icon="search"
        >
        </v-text-field>
      </v-layout>
      <v-data-table
        :search="satXmlDownloadSearch"
        class="elevation-2 mb-5"
        :headers="filteredHeaders"
        :items="xmlDownload"
        :loading="loadingItems"
        :pagination.sync="pagination"
      >
        <template v-slot:headers="props">
          <tr class="bg-heavy-rain">
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                'column',
                header.sortable ? 'sortable' : '',
                pagination.descending ? 'desc' : 'asc',
                header.value === pagination.sortBy ? 'active' : '',
              ]"
              @click="changeSort(header.value)"
            >
              <h2 class="font-weight-black primary--text mb-0">
                <v-icon small class="primary--text" v-if="header.sortable"
                  >arrow_upward</v-icon
                >
                {{ header.text }}
              </h2>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr>
            <td>{{ props.item.id ? props.item.id : '- -' }}</td>
            <td class="text-sm-center">
              {{
                props.item.gst_expenses_id ? props.item.gst_expenses_id : '- -'
              }}
            </td>
            <td class="text-sm-center">
              {{ props.item.user ? props.item.user.name : '- -' }}
            </td>
            <td class="text-sm-center">
              {{ props.item.uuid ? props.item.uuid : '- -' }}
            </td>
            <td class="text-sm-center">
              {{
                props.item.expenses_items &&
                props.item.expenses_items.description
                  ? props.item.expenses_items.description
                  : '- -'
              }}
            </td>
            <td class="text-sm-center">
              {{ props.item.expenses ? props.item.expenses.start_date : '- -' }}
              {{
                props.item.expenses ? ' ' + props.item.expenses.end_date : '- -'
              }}
            </td>
            <td class="text-sm-center">
              {{
                props.item.expenses_items
                  ? props.item.expenses_items.issue_date
                  : '- -'
              }}
            </td>
            <!-- <td class="text-sm-center"> -->
            <td
              class="text-sm-center"
              v-if="userLogged.roles && userLogged.roles[0].name === 'ADMIN'"
            >
              <v-layout row justify-center>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      small
                      outline
                      icon
                      color="info"
                      v-on="on"
                      @click="editItem(props.item)"
                    >
                      <v-icon small>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('general.edit') }}</span>
                </v-tooltip>
              </v-layout>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-speed-dial
        class="download-btn"
        v-model="fab"
        :right="right"
        :bottom="bottom"
        :direction="direction"
        :open-on-hover="hover"
        :transition="transition"
        :fixed="true"
        :absolute="false"
      >
        <template v-slot:activator>
          <v-btn v-model="fab" dark fab color="primary">
            <v-icon v-if="fab">close</v-icon>
            <v-icon v-else>file_download</v-icon>
          </v-btn>
        </template>
        <v-btn fab small color="normal">
          <a
            id="linkDownloadApp"
            href="https://s.intekel.com/satdownload-win"
          >
            <v-icon>mdi-windows</v-icon>
          </a>
        </v-btn>
        <v-btn fab small color="normal">
          <a
            id="linkDownloadApp"
            href="https://s.intekel.com/satdownload-linux"
          >
            <v-icon>mdi-linux</v-icon>
          </a>
        </v-btn>
        <v-btn fab small color="normal">
          <a
            id="linkDownloadApp"
            href="https://s.intekel.com/satdownload-mac"
          >
            <v-icon>mdi-apple</v-icon>
          </a>
        </v-btn>
      </v-speed-dial>
    </v-container>
    <!-- Diálogo para editar comprobación -->
    <v-dialog v-model="dialogEdit" max-width="600px" persistent>
      <v-card>
        <v-toolbar flat>
          <h2 class="font-weight-black primary--text mb-0">
            {{ this.$t('expenses.edit') }}
          </h2>
        </v-toolbar>
        <v-card-text>
          <v-form lazy-validation ref="form" v-model="valid">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-menu
                    v-model="start"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        clearable
                        required
                        :rules="rules.required"
                        :error-messages="errors.start_date"
                        v-model="editedItem.start_date"
                        :label="$t('general.startDate')"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      >
                      </v-text-field>
                    </template>
                    <v-date-picker
                      color="primary"
                      :locale="$t('general.locale')"
                      v-model="editedItem.start_date"
                      :max="maxDate"
                      @input="start = false"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-menu
                    v-model="end"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        clearable
                        required
                        :rules="rules.required"
                        v-model="editedItem.end_date"
                        :error-messages="errors.end_date"
                        :label="$t('general.endDate')"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      >
                      </v-text-field>
                    </template>
                    <v-date-picker
                      color="primary"
                      :locale="$t('general.locale')"
                      v-model="editedItem.end_date"
                      :min="minDate"
                      @input="end = false"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" round flat @click="close">
            {{ $t('general.cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            round
            depressed
            :loading="loading"
            :disabled="loading"
            @click="save"
          >
            {{ $t('general.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'SatXMLDownloadComponent',
  data () {
    return {
      loading: false,
      satXmlDownloadSearch: '',
      direction: 'top',
      fab: false,
      fling: false,
      hover: true,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: 'slide-y-reverse-transition',
      dialog: false,
      removeDialog: false,
      valid: true,
      xmlDownload: [],
      apiBuffer: '',
      pagination: {
        descending: true,
        sortBy: 'expenses_items.issue_date',
        page: 1,
        rowsPerPage: 25
      },
      loadingItems: true,
      userLogged: {},
      isDisabledPettyCash: false,
      isDisabledAdvance: false,
      isDisabledRefund: false,
      editedIndex: -1,
      editedItem: {
        id: null,
        user_id: null,
        start_date: '',
        end_date: '',
        description: '',
        project_id: '',
        status: '',
        expenses_status: '',
        advance: 0,
        is_petty_cash: false,
        viatic_request_id: null,
        has_request: false
      },
      defaultItem: {
        id: null,
        user_id: null,
        start_date: '',
        end_date: '',
        description: '',
        project_id: '',
        status: '',
        expenses_status: '',
        advance: 0,
        is_petty_cash: false,
        viatic_request_id: null,
        has_request: false
      },
      dialogEdit: false,
      start: false,
      end: false,
      errors: {},
      type: 'refund',
      ifViatics: false
    }
  },
  computed: {
    heading () {
      return this.$t('general.satXmlDownload')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'fas fa-cloud-download-alt fa-fw icon-color'
    },
    headersXml () {
      return [
        {
          text: '#',
          align: 'center',
          value: 'id',
          sortable: true
        },
        {
          text: this.$t('workflowValidation.abbrExpenseNo'),
          align: 'center',
          value: 'gst_expenses_id',
          sortable: true
        },
        {
          text: this.$t('user.name'),
          align: 'center',
          value: 'user.name',
          sortable: true
        },
        {
          text: this.$t('general.uuid'),
          align: 'center',
          value: 'uuid',
          sortable: true
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'expenses.description',
          sortable: true
        },
        {
          text: this.$t('conciliation.period'),
          align: 'center',
          value: 'expenses.start_date',
          sortable: true
        },
        {
          text: this.$t('general.expenseDate'),
          align: 'center',
          value: 'expenses_items.issue_date',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]
    },
    linkDownload () {
      return this.apiBuffer
    },
    filteredHeaders () {
      if (this.userLogged.roles && this.userLogged.roles[0].name === 'ADMIN') {
        return this.headersXml.filter((x) => x.text !== '')
      } else {
        return this.headersXml
      }
    },
    rules () {
      return this.$validationRules()
    },
    minDate () {
      let minDate = ''
      if (
        this.editedItem.start_date !== '' &&
        this.editedItem.start_date !== null
      ) {
        minDate = new Date(this.editedItem.start_date)
          .toISOString()
          .substr(0, 10)
      }
      return minDate
    },
    maxDate () {
      let maxDate = ''
      if (
        this.editedItem.end_date !== '' &&
        this.editedItem.end_date !== null
      ) {
        maxDate = new Date(this.editedItem.end_date).toISOString().substr(0, 10)
      }
      return maxDate
    }
  },
  watch: {
    userLogged () {
      if (this.$store.state.userLogged.company !== undefined) {
        this.get()
      }
    },
    '$store.state.userLogged' () {
      this.getLogged()
    },
    type () {
      if (this.type === 'pettyCash') {
        this.editedItem.advance = 0
        this.editedItem.is_petty_cash = 1
      } else if (this.type === 'advance') {
        this.editedItem.is_petty_cash = 0
      } else if (this.type === 'refund') {
        this.editedItem.advance = 0
        this.editedItem.is_petty_cash = 0
      }
    }
  },
  created () {
    // this.get()
    this.getLogged()
  },
  methods: {
    getLogged () {
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
      }
    },
    changeSort (header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    get () {
      this.$emit('get', {
        context: this
      })
    },
    editItem (val) {
      const item = val.expenses
      if (item.advance === '0.00' && item.is_petty_cash === 0) {
        this.type = 'refund'
        this.isDisabledPettyCash = true
        this.isDisabledAdvance = false
        this.isDisabledRefund = false
      } else if (item.advance !== '0.00') {
        this.type = 'advance'
        this.isDisabledPettyCash = true
        this.isDisabledAdvance = false
        this.isDisabledRefund = true
      } else if (item.is_petty_cash === 1) {
        this.type = 'pettyCash'
        this.isDisabledPettyCash = false
        this.isDisabledAdvance = true
        this.isDisabledRefund = true
      }
      this.editedItem = Object.assign({}, item)
      this.editedItem.viatic_request_id =
        item.gst_travel_expenses_request_id !== null
          ? item.gst_travel_expenses_request_id
          : null
      if (item.gst_travel_expenses_request_id !== null) {
        this.editedItem.has_request = true
      } else {
        this.editedItem.has_request = false
      }
      this.dialogEdit = true
    },
    close () {
      this.loading = false
      this.errors = {}
      this.dialogEdit = false
      this.isPettyCash = false
      this.isDisabledPettyCash = false
      this.isDisabledRefund = false
      this.isDisabledAdvance = false
      this.type = 'refund'
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.$refs.form.resetValidation()
    },
    save () {
      this.errors = {}
      if (this.$refs.form.validate()) {
        this.put()
      }
    },
    put () {
      if (
        this.userLogged &&
        this.userLogged.roles &&
        this.userLogged.roles[0].name === 'ADMIN'
      ) {
        this.loading = true
        this.$emit('putExpense', {
          item: this.editedItem,
          index: this.editedIndex,
          context: this
        })
      }
    },
    refresh () {
      this.get()
    }
  }
}
</script>
<style>
.download-btn {
  margin-bottom: 45px;
  margin-right: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/satXMLDownload.component.vue